import React, {useEffect, useMemo, useState} from 'react';
import {
    type MRT_ColumnFiltersState,
    type MRT_PaginationState,
    type MRT_SortingState,
    MRT_EditActionButtons,
    MaterialReactTable,
    createRow,
    type MRT_ColumnDef,
    useMaterialReactTable, type MRT_Row,
} from 'material-react-table';
import {
  QueryClient,
} from '@tanstack/react-query';
import {Box, Button, CircularProgress, IconButton, Stack, Tooltip} from '@mui/material';
import {useNavigate} from "react-router-dom";
import {useGetAllReportSospVersore} from "./Services";
import {ReportSospVersore} from "./types";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableRowsIcon from '@mui/icons-material/TableRows';
import ReportSospVersoreJasper from "./ReportSospVersoreJasper";
import ReportSospVersoreExp from "./ReportSospVersoreExp";
import EditIcon from "@mui/icons-material/Edit";
import EditVersOre from "../gestversore/EditVersOre";
import DeleteIcon from "@mui/icons-material/Delete";
import {VersOreDTO} from "../gestversore/types";
import {useTabSettings} from "../../common/Services";
import ReportAgentiVersoreExp from "../reportagentiversore/ReportAgentiVersoreExp";

interface ListaReportSospVersoreProps {
  // propflgtemp: string;
}

// const VersOre = () => {
const ListaReportSospVersore: React.FC<ListaReportSospVersoreProps> = () => {
  const [validationErrors, setValidationErrors] = useState< Record<string, string | undefined>>({});
  const [globalFilter, setGlobalFilter] = useState('');


   const storeCodCli = localStorage.getItem('keycodclifor') ?? '';
   const storeDitta = localStorage.getItem('keyidazienda') ?? '';


   const openEditModal = (row: MRT_Row<VersOreDTO>) => {
       setIsDialogEditOpen(true);
       setCurrentRowId(row.id);
   };



  const columns = useMemo<MRT_ColumnDef<ReportSospVersore>[]>(
    () => [
    {
        accessorKey: 'nrrel',
        header: 'NrRel',
        size: 5,
        enableEditing: false,
    },

    {
        accessorKey: 'ditta',
        header: 'Ditta',
        size: 5,
        enableEditing: false,

    },
    {
        accessorKey: 'coddip',
        header: 'Dip',
        size: 5,
        enableEditing: false,
    },
    {
          accessorKey: 'datareg',
          header: 'Data',
          enableEditing: true,
          filterVariant: "date-range",
          size: 10,
          Cell: ({cell}) => {
              const value = cell.getValue();
              if (typeof value === 'string' || typeof value === 'number') {
                  const date = new Date(value);
                  return date.toLocaleDateString('it-IT'); // Change 'it-IT' to your desired locale
              } else {
                  return 'Nessuna Data';
              }
          },
    },
    { accessorKey: 'ragsoccli', header: 'Cliente', size: 5, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 20 ? `${value.substring(0, 20)}...` : value}</span> ); }, },
    { accessorKey: 'desprog', header: 'Progetto', size: 5, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 30 ? `${value.substring(0, 30)}...` : value}</span> ); }, },
    { accessorKey: 'desnodo', header: 'Nodo', size: 5, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 20 ? `${value.substring(0, 20)}...` : value}</span> ); }, },



    {
        accessorKey: 'desatt',
        header: 'Attivita',
        size: 5,
        enableEditing: true,
    },
 { accessorKey: 'note', header: 'Note', size: 5, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 40 ? `${value.substring(0, 40)}...` : value}</span> ); }, },



   {
        accessorKey: 'opzfatt',
        header: 'Fatt',
        size: 5,
        enableEditing: false,
    },
    {
        accessorKey: 'oreord',
        header: 'Ore',
        size: 5,
        enableEditing: false,
    },
    {
        accessorKey: 'codart',
        header: 'CodArt',
        size: 5,
        enableEditing: true,
    },
    {
        accessorKey: 'imprigo',
        header: 'PrUnit',
        size: 5,
        enableEditing: true,
    },
    {
        accessorKey: 'nomeagente',
        header: 'Agente',
        size: 5,
        enableEditing: false,

    },

    ],
    [validationErrors],
  );



   const keyusername = localStorage.getItem('keyusername') || 'NN';
   const {  columnVisibility,  setColumnVisibility,  columnFilters,  setColumnFilters,  sorting,  setSorting, pagination,  setPagination,  saveTabSettings,} = useTabSettings('ListaReportSospVersore', keyusername);


  //call READ hook
  const {  data: { results = [], count } = {} ,isError: isLoadingReportSospVersoreError, isFetching: isFetchingReportSospVersore, isLoading: isLoadingReportSospVersore} = useGetAllReportSospVersore(pagination,columnFilters,globalFilter,sorting);

  const [isDialogExporterOpen, setIsDialogExporterOpen] = useState(false);

  const [isDialogReportSospVersoreExpPDF, setIsDialogReportSospVersorePDF] = useState(false);
  const [isDialogReportSospVersoreExpXLS, setIsDialogReportSospVersoreXLS] = useState(false);



  const [draftColumnFilters, setDraftColumnFilters] = useState<MRT_ColumnFiltersState>(columnFilters);


  const [isDialogEditOpen, setIsDialogEditOpen] = useState(false);
  const [currentRowId, setCurrentRowId] = useState('0');



  const table = useMaterialReactTable({
    columns,
    data: results,
    initialState: { density: 'compact' },

    /*
    muiPaginationProps: {
      disabled: isFetchingReportSospVersore,
    },
    */

    manualFiltering: true, //turn off built-in client-side filtering
    manualPagination: true, //turn off built-in client-side pagination
    manualSorting: true, //turn off built-in client-side sorting

    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)

    enableEditing: false,
    enableRowActions: true,
    enableColumnActions: false,

    //getRowId: (row) => row.id.toString(),

    // getRowId: (row) => (row.id ? row.id.toString() : ''),

    getRowId: (row) => (row.nrrel ? row.nrrel.toString() : ''),

    muiToolbarAlertBannerProps: isLoadingReportSospVersoreError ? {
          color: 'error',
          children: 'Error loading data',
        } : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: '500px',
      },
    },

    // per compattazione tabella padding first above and below second left and right
     muiTableBodyCellProps: {
          sx: {
            padding: '0.5px 4px',
            fontSize: '.9rem',
          },
        },

     muiTableHeadCellProps: {
          sx: {
            padding: '0.5px 4px',
            fontSize: '0.9rem',
          },
        },
// fine compattazione vedi anche row actions


    // muiEditRowDialogProps: {
    //    fullWidth: true,
    //    maxWidth: 'md',
    //  },
    // onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    // onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    onCreatingRowCancel: () => setValidationErrors({}),
    onEditingRowCancel: () => setValidationErrors({}),

    onColumnFiltersChange: (updater) => {
      const newFilters = typeof updater === 'function' ? updater(columnFilters) : updater;
      setColumnFilters(newFilters);
      saveTabSettings(columnVisibility, newFilters, sorting, pagination);
    },
    onSortingChange: (updater) => {
      const newSorting = typeof updater === 'function' ? updater(sorting) : updater;
      setSorting(newSorting);
      saveTabSettings(columnVisibility, columnFilters, newSorting, pagination);
    },
    onPaginationChange: (updater) => {
      const newPagination = typeof updater === 'function' ? updater(pagination) : updater;
      setPagination(newPagination);
      saveTabSettings(columnVisibility, columnFilters, sorting, newPagination);
    },

    onColumnVisibilityChange: (updater) => {
      const newVisibility = typeof updater === 'function' ? updater(columnVisibility) : updater;
      setColumnVisibility(newVisibility);
      saveTabSettings(newVisibility, columnFilters, sorting,pagination);
    },




   renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '0.20rem' }}>

       <Tooltip title="Modifica">
          <IconButton  size="small"  onClick={() => openEditModal(row)}>
            <EditIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Tooltip>
       {/*{isDialogEditOpen && currentRowId === row.id && <EditVersOre id={(Number(currentRowId))} onClose={()  => setIsDialogEditOpen(false) } />}*/}
           {isDialogEditOpen && currentRowId === row.id && (
              <EditVersOre
                id={Number(currentRowId)}
                isReadOnly={false}
                onClose={() => setIsDialogEditOpen(false)}
              />
            )}


      </Box>


    ),




  renderTopToolbarCustomActions: ({ table }) => (

    <>
                <Stack
                  direction="row"
                  spacing={0}
                  sx={{
                    width: '60%',
                    padding: '4px',
                    alignItems: 'center',
                  }}
                >

              <Box sx={{ width: '25%' }} />

              <Box sx={{ width: '25%' }} />


              <Box sx={{ width: '25%'  }}>
                <Button
                  variant="contained"
                  onClick={() => setIsDialogExporterOpen(true)}
                  startIcon={<FileDownloadIcon />}
                  sx={{ width: 160 }}
                >
                  EXPORT DATI
                </Button>

                {isDialogExporterOpen && (
                  <ReportSospVersoreExp
                      pagination={pagination}
                      columnFilters={columnFilters}
                      globalFilter={globalFilter}
                      sorting={sorting}
                      columnVisibility={columnVisibility}
                      columns={columns}
                      onClose={() => setIsDialogExporterOpen(false)}
                  />
                )}
              </Box>

              {/* Slot 3: Applica Filtri */}
              <Box sx={{ width: '25%'}}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setColumnFilters(draftColumnFilters);
                    saveTabSettings(columnVisibility, draftColumnFilters, sorting, pagination);
                  }}
                  sx={{ width: 160 }}
                >
                  Applica Filtri
                </Button>
              </Box>

            </Stack>

   </>
   ),


    //rowCount: meta?.totalRowCount ?? 0,
    rowCount: count ?? 0,

    state: {
      columnFilters,
      globalFilter,
      pagination,
      sorting,
      columnVisibility,
      isLoading: isLoadingReportSospVersore,
      // isSaving: isDeletingReportSospVersore,
      showAlertBanner: isLoadingReportSospVersoreError,
      showProgressBars: isFetchingReportSospVersore,
    },
  });

 // return (
 //
 //     <Box sx={{ mt: "60px" }}>
 //      {isLoadingReportSospVersore ? (
 //        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "500px" }}>
 //          <CircularProgress size={80} />
 //        </Box>
 //      ) : (
 //        <MaterialReactTable table={table} />
 //      )}
 //    </Box>
 //
 //  );
 //
 return (

     <Box sx={{ mt: "60px" }}>
              <MaterialReactTable table={table} />
    </Box>

  );


};


export default ListaReportSospVersore;

const validateRequired = (value: string) => !!value.length;
const validateRequiredNum = (value: number) => !!value.toString().length;
const validateEmail = (email: string) =>
  !!email.length &&
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );


